import styled, { css } from 'styled-components';

import { Box } from '@/styles/shared';
import { query } from 'atomic-layout';

interface IContainer {
  widgetIsOpen: boolean;
}

export const Container = styled(Box)<IContainer>`
  height: 0;
  right: 24px;
  bottom: 96px;
  z-index: 999;
  display: flex;
  position: fixed;
  overflow: hidden;
  border-radius: 12px;
  flex-direction: column;
  filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.15));
  background-color: ${props => props.theme.colors.display[0]};
  z-index: 99999;
  max-width: 360px;
  width: 100%;

  form {
    max-height: 100%;
    flex: 1;
  }

  ${props =>
    props.widgetIsOpen &&
    css`
      height: 640px;
      overflow: unset;

      @media (max-height: 750px) {
        max-height: 80%;
        height: 100%;
      }

      @media (max-height: 550px) {
        max-height: 100%;
        height: 100%;
        bottom: 0;
        right: 0;
        border-radius: 0;
      }
    `}

  @media ${query({ to: 'sm' })} {
    top: 0;
    right: 0;
    bottom: 24px;
    border-radius: 0 0 4px 4px;

    ${props =>
      props.widgetIsOpen &&
      css`
        max-height: 100%;
        max-width: 100%;
        width: 100%;
        height: 100%;
      `}

    form {
      overflow: auto;
    }
  }

  ${props =>
    props.widgetIsOpen &&
    css`
      @media screen and (max-width: 868px) and (orientation: landscape) {
        top: 0;
        right: 0;
        bottom: 0;
        max-width: 100%;
        max-height: 100%;
        width: 100%;
        height: 100%;
        border-radius: 0;
      }
    `}
`;
